import { OnInit } from '@angular/core';
import { EnvironmentService } from '../../core/environment/environment.service';
import * as i0 from "@angular/core";
import * as i1 from "../../core/environment/environment.service";
var AlertTemplate = /** @class */ (function () {
    function AlertTemplate(environmentService) {
        this.environmentService = environmentService;
        this.authSettings = this.environmentService.envModel.authSettings;
        this.urlOpenId = this.environmentService.envModel.appSettings.apiUrlLogout;
    }
    AlertTemplate.prototype.ngOnInit = function () {
    };
    AlertTemplate.prototype.template = function (id, language) {
        var template = [
            {
                id: 1,
                language: 'br',
                title: "Sessão Expirada",
                html: 'Desculpe, sua sessão expirou devido a inatividade. \n <a href="' + this.urlOpenId + '">Clique aqui</a> para fazer login novamente.'
            },
            {
                id: 1,
                language: 'es',
                title: "Sessão Expirada",
                html: 'Desculpe, sua sessão expirou devido a inatividade. \n <a href="' + this.urlOpenId + '">Clique aqui</a> para fazer login novamente. ES'
            },
            {
                id: 1,
                language: 'us',
                title: "Sessão Expirada",
                html: 'Desculpe, sua sessão expirou devido a inatividade. \n <a href="' + this.urlOpenId + '">Clique aqui</a> para fazer login novamente. US'
            },
            {
                id: 2,
                language: 'br',
                title: "Erro ao efetuar login",
                html: 'Problema ao efetuar login, gostaria de tentar novamente? \n <a href="' + this.urlOpenId + '">Clique aqui</a> para fazer login novamente.'
            },
            {
                id: 2,
                language: 'es',
                title: "Erro ao efetuar login",
                html: 'Problema ao efetuar login, gostaria de tentar novamente? \n <a href="' + this.urlOpenId + '">Clique aqui</a> para fazer login novamente. ES'
            },
            {
                id: 2,
                language: 'us',
                title: "Erro ao efetuar login",
                html: 'Problema ao efetuar login, gostaria de tentar novamente? \n <a href="' + this.urlOpenId + '">Clique aqui</a> para fazer login novamente. US'
            },
        ];
        return template.filter(function (x) { return x.id === id && x.language === language; });
    };
    AlertTemplate.ngInjectableDef = i0.defineInjectable({ factory: function AlertTemplate_Factory() { return new AlertTemplate(i0.inject(i1.EnvironmentService)); }, token: AlertTemplate, providedIn: "root" });
    return AlertTemplate;
}());
export { AlertTemplate };
